import React from 'react';
import { observer } from 'mobx-react-lite';
import NotificationItem from '../notificationItem';
import { NotificationListProps } from '../../../interfaces/NotificationInterface';

const NotificationList: React.FC<NotificationListProps> = ({
  notifications,
  buttonRef,
  mobile,
  swipedItemId,
  touchStartX,
  touchEndX,
  isRearranging,
  deletingId,
  openDropdownId,
  subDropdownOpen,
  onClickInboxItem,
  onHoverChange,
  onClickReadIcon,
  onClickDeleteIcon,
  handleTouchStart,
  handleTouchMove,
  handleTouchEnd,
  handleSubDropdownOpen,
  onClickUpdateStatus,
  onClickGroup,
  onClickUpdatePriority,
  isRecurringTask,
  isTemplateProject,
  calendarDate,
  setCalendarDate,
  menuItems,
  isImageDescription,
  githubSvgIcon,
  setSubDropdownOpen,
  snoozeMenuItems,
  onClickSnoozeIcon,
  handleClick,
  handleTimeChange,
  onCancelSnooze,
  onClickSnooze,
  dropdownRefCalendar,
  onDateChange
}) => {
  if (!notifications || notifications.length === 0) return null;

  return (
    <>
      {notifications.map((item, index) => {
        if (!buttonRef.current[index]) {
          buttonRef.current[index] = React.createRef<HTMLDivElement>();
        }
        const currentProject = item?.taskId ? item?.task?.project : null;
        return (
          <NotificationItem
            key={item.id}
            item={item}
            index={index}
            mobile={mobile}
            swipedItemId={swipedItemId}
            touchStartX={touchStartX}
            touchEndX={touchEndX}
            isRearranging={isRearranging}
            deletingId={deletingId}
            openDropdownId={openDropdownId}
            subDropdownOpen={subDropdownOpen}
            onClickInboxItem={onClickInboxItem}
            onHoverChange={onHoverChange}
            onClickReadIcon={onClickReadIcon}
            onClickDeleteIcon={onClickDeleteIcon}
            handleTouchStart={handleTouchStart}
            handleTouchMove={handleTouchMove}
            handleTouchEnd={handleTouchEnd}
            handleSubDropdownOpen={handleSubDropdownOpen}
            onClickUpdateStatus={onClickUpdateStatus}
            onClickGroup={onClickGroup}
            onClickUpdatePriority={onClickUpdatePriority}
            isRecurringTask={isRecurringTask}
            isTemplateProject={isTemplateProject}
            calendarDate={calendarDate}
            setCalendarDate={setCalendarDate}
            currentProject={currentProject}
            menuItems={menuItems}
            isImageDescription={isImageDescription}
            githubSvgIcon={githubSvgIcon}
            setSubDropdownOpen={setSubDropdownOpen}
            snoozeMenuItems={snoozeMenuItems}
            onClickSnoozeIcon={onClickSnoozeIcon}
            handleClick={handleClick}
            handleTimeChange={handleTimeChange}
            onCancelSnooze={onCancelSnooze}
            onClickSnooze={onClickSnooze}
            dropdownRefCalendar={dropdownRefCalendar}
            onDateChange={onDateChange}
          />
        );
      })}
    </>
  );
};

export default observer(NotificationList);
